import { render, staticRenderFns } from "./Supplement.vue?vue&type=template&id=00ae2af2&scoped=true"
import script from "./Supplement.vue?vue&type=script&lang=js"
export * from "./Supplement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae2af2",
  null
  
)

export default component.exports